export const QUERY_PARAMS = {
  token: 'token',
  loginHint: 'login_hint'
};
